import React from "react";
import styled from "styled-components";
import { theme, prop } from "styled-tools";

const Dot = styled.div`
  width: ${prop("size", 14)}px;
  height: ${prop("size", 14)}px;
  border-radius: 50%;
  flex: 0 0 auto;
  background-color: ${p =>
    p.muted
      ? theme("colors.grays.1", "#d8d8d8")(p)
      : theme(`colors.ratings.${p.colorIndex}`, "black")(p)};
`;

function RatingDot({ rating, size, ...rest }) {
  // An attendee nobody reviewed arrives as NaN (a mean of zero reviews), and
  // every comparison below is false for NaN — which painted "not rated yet" as
  // the same red as the worst possible score.
  // Null and '' coerce to 0, which would paint "not rated" as the worst score.
  if (rating === null || rating === undefined || rating === '') return <Dot muted size={size} />;
  const value = Number(rating);
  if (!Number.isFinite(value)) return <Dot muted size={size} />;

  // Colour by the nearest whole band, the same rule the API's band label uses
  // (spec Appendix A). Rounding up instead painted a 2.2 composite in the Good
  // colour right next to the word "Fair".
  const colorIndex = Math.min(5, Math.max(1, Math.round(value))) - 1;

  return <Dot colorIndex={colorIndex} size={size} />;
}

export default RatingDot;
